export default {
  GETINFO_BY_INVITECODE: '/User/GetInfoByInviteCode',

  //获取功德榜单
  VirtueRank: '/User/virtueRank',
};
